import { gsap } from "gsap";
import { smootherStop } from "./parallax";
import Modernizr from '../vendor/modernizr-custom.js'
let mobilePopupTl = gsap.timeline({
  paused: true,
});

export default function formInit() {
  const contactusWrapper = document.querySelectorAll(".contactus-wrapper");
  function BindContactusClickfn()
  {
    contactusWrapper.forEach((contactForm) => {
      contactForm.addEventListener("click", (e) => {
      e.preventDefault();
      if(window.location.pathname =="/global-brand-solutions/creative-production/presentation-services")
      {
          localStorage.setItem("isPresentationService", true);
      }
      else{
        localStorage.setItem("isPresentationService", false);
      }
      window.location = '/contact-us';
    })
  });
  }
  BindContactusClickfn();
}
